import { getComplains, deleteComplain, updateComplain } from '../services/napi';
import { COMPLAINS_FETCH_SUCCESS } from '../constant/actionType';

export function fetchAllComplains() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getComplains(projectId);
      dispatch({
        data: response.data.reports,
        type: COMPLAINS_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function deleteComplainAction(projectId, complainId, onSuccess) {
  return async () => {
    await deleteComplain(projectId, complainId);
    onSuccess();
  };
}

export function updateComplainAction(projectId, complainId, body, onSuccess) {
  return async () => {
    await updateComplain(projectId, complainId, body);
    onSuccess();
  };
}
